import type { Board } from 'chessboard/model/board/types';
import { Game } from 'chessboard/model/game/types';

/**
 * Determine from the flags if a move is an EP Capture.
 */
export function getEPCapturedSquare(move: Game.Move.Model): Board.SanSquare | undefined {
  if (move.flags !== Game.Move.Flags.EPCapture || !move.from) {
    return;
  }

  return <Board.SanSquare>`${move.to.slice(0, 1)}${move.from.slice(-1)}`;
}
